import { DataTablePagination, PanelInfo } from '@/components/custom';
import { usePaymentMethodRequests } from '../hooks';
import Loader from '@/components/custom/Loader';
import { CreditCard } from 'lucide-react';
import DataTable from './dataTable';

const ViewData = () => {

  const { isLoading, data, paymentMethodRequests } = usePaymentMethodRequests();

  if (isLoading) {
    return (
      <div className='my-10'>
        <Loader className='my-10' />
      </div>
    );
  }

  if (paymentMethodRequests.length === 0) {
    return (
      <PanelInfo
        title='Aucune demande trouvée'
        description={`Il n'existe pas de demande de moyen de paiement respectant ces critères.`}
        className='py-10 md:py-26 border-none'
        icon={CreditCard} />
    );
  }

  return (
    <div className='space-y-5 animate__animated animate__fadeIn'>
      <DataTable />
      <DataTablePagination pageCount={data.pagination.pageCount} />
    </div>
  );

};

export default ViewData;
